<div class="banner d-lg-flex d-none">
  <div class="container d-flex justify-content-between align-items-center h-100">
    <h1>{{ pageTitle }}</h1>
    <div class="d-flex align-items-center">
      <img class="banner-logo" src="assets/images/Logos/RedbullsMemberPlusWhite.svg" />
    </div>
  </div>
</div>
